
import React from 'react';
import { useAuth } from '../../auth/AuthContext';
import { Button } from '@dhis2/ui';

const VerificationRequiredBanner = () => {
    const { verificationRequired, resendVerification, user } = useAuth();

    if (!verificationRequired) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            pointerEvents: 'none',
        }}>
            <div style={{
                backgroundColor: '#fff',
                color: '#333',
                padding: '30px',
                borderRadius: '12px',
                maxWidth: '450px',
                width: '90%',
                boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                pointerEvents: 'auto',
                textAlign: 'center',
            }}>
                <h2 style={{ color: '#e67e22', marginTop: 0 }}>📧 Email Verification Required</h2>
                <p style={{ fontSize: '16px', lineHeight: 1.6 }}>
                    Your email address <strong>{user?.email}</strong> has not been verified.
                    Please check your inbox for the verification link.
                </p>
                <p style={{ fontSize: '14px', color: '#666' }}>
                    The link expires in 24 hours. If you didn't receive it, click the button below to resend.
                </p>
                <div style={{ marginTop: 25, display: 'flex', gap: '12px', justifyContent: 'center' }}>
                    <Button primary onClick={resendVerification}>
                        Resend Verification Email
                    </Button>
                    <Button
                        secondary
                        onClick={() => {
                            // Optionally log out – you may need to clear DHIS2 session
                            // For DHIS2, you can redirect to /dhis-web-commons/security/logout.action
                            window.location.href = '/dhis-web-commons/security/logout.action';
                        }}
                    >
                        Logout
                    </Button>
                </div>
                <p style={{ fontSize: '12px', color: '#999', marginTop: 20 }}>
                    Already verified? Try <a href="/login" style={{ color: '#4a90e2' }}>logging in again</a>.
                </p>
            </div>
        </div>
    );
};

export default VerificationRequiredBanner;